import { serverFetch } from "@core/server";

export function fetchSprTovList() {
  return serverFetch("sprs/tov");
}

export function fetchSprTov(idTov) {
  return serverFetch(`sprs/tov/${idTov}`);
}

export function fetchSprTovKomplekts() {
  return serverFetch("sprs/tov/komplekts");
}

export function fetchSprTovRests(idTov) {
  return serverFetch(`sprtov/${idTov}/rests`);
}

export function fetchSprTovRestTotals() {
  return serverFetch("sprtov/rests");
}

export function createSprTov(bodyData) {
  return serverFetch("sprs/tov", {
    method: "POST",
    bodyData
  });
}

export function saveSprTov(bodyData) {
  return serverFetch("sprs/tov", {
    method: "PUT",
    bodyData
  });
}

export function deleteSprTov(idTov) {
  return serverFetch(`sprs/tov/${idTov}`, {
    method: "DELETE"
  });
}

export function fetchSprTovParams(idTov) {
  return serverFetch(`sprs/tov/${idTov}/params`);
}

export function createSprTovParam(idTov, bodyData) {
  return serverFetch(`sprs/tov/${idTov}/params`, {
    method: "POST",
    bodyData
  });
}

export function updateSprTovParam(idTov, idParamName, bodyData) {
  return serverFetch(`sprs/tov/${idTov}/params/${idParamName}`, {
    method: "PUT",
    bodyData
  });
}

export function deleteSprTovParam(idTov, idParamName) {
  return serverFetch(`sprs/tov/${idTov}/params/${idParamName}`, {
    method: "DELETE"
  });
}

export function createSprTovParamValue(idTov, idParamName, bodyData) {
  return serverFetch(`sprs/tov/${idTov}/params/${idParamName}/values`, {
    method: "POST",
    bodyData
  });
}

export function updateSprTovParamValue(idTov, idParamName, idParamValue, bodyData) {
  return serverFetch(`sprs/tov/${idTov}/params/${idParamName}/values/${idParamValue}`, {
    method: "PUT",
    bodyData
  });
}

export function deleteSprTovParamValue(idTov, idParamName, idParamValue) {
  return serverFetch(`sprs/tov/${idTov}/params/${idParamName}/values/${idParamValue}`, {
    method: "DELETE"
  });
}

export function fetchSprTovDeny(idTov) {
  return serverFetch(`sprs/tov/${idTov}/deny`);
}

export function addSprTovDeny(idTov, bodyData) {
  return serverFetch(`sprs/tov/${idTov}/deny`, {
    method: "POST",
    bodyData
  });
}

export function removeSprTovDeny(idTov, idTovDeny) {
  return serverFetch(`sprs/tov/${idTov}/deny/${idTovDeny}`, {
    method: "DELETE"
  });
}
